import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const authorHandleResolver: FieldResolver = (metadata: Metadata) =>
  ({ authorHandle: metadata.getAuthorHandle() } as StreamData)

export default authorHandleResolver
